import React, { useEffect, useState } from "react";
import {
  Switch,
  Route,
  Redirect,
  useParams,
  useHistory,
} from "react-router-dom";
import teamroutes from "teamroutes.js";
import Footer from "components/Footer";
import routes from "routes";
import sidebar_routes from "sidebar_routes";
import RightSidebar from "components/Sidebar/RightSidebar";
import Sidebar from "components/Sidebar/Sidebar.js";
import Navbar from "components/Navbars/Navbar.js";
import { useGlobalContext } from "store/contexts/globalContext";
import Scrollbar from "react-scrollbars-custom";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import { TeamContext } from "store/contexts/teamContext";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import * as timelineActions from "reteamStore/actions";
import { useSelector } from "react-redux";
import { TeamActionContext } from "store/contexts/teamActionContext";
import * as microsoftTeams from "@microsoft/teams-js";
import pollServices from "services/pollServices";
import { scrollToTopOfTimeline } from "utils/helpers";
import { useUserContext } from "store/contexts/userContext";
import CourseService from "services/CourseService";

export default function TeamActions({ ...rest }) {
  const { pollQuestion } = useSelector((state) => state.pollListReducer);
  const { timelineTodoList } = useSelector((state) => state.todoListReducer);
  // const { courses } = useSelector((state) => state.courseReducer);
  // const { companyData } = useSelector((state) => state.companyReducer)
  const { teams } = useSelector((state) => state.teamsReducer);
  const [sortData, setSortData] = useState(null);
  const { user } = useUserContext();

  let location = useLocation();
  const dispatch = useDispatch();
  var locationName = location.pathname.split("/");
  const color = "white";

  const userStr = localStorage.getItem("user");
  const localUser = userStr ? JSON.parse(userStr) : null;
  const isSiteAdmin = localUser && localUser.roles && localUser.roles.includes("Site Admin");
  const filteredRoutes = routes.filter(route => route.name !== "Support Ticket" || isSiteAdmin);

  const [team_routes] = useState([...teamroutes, ...sidebar_routes]);
  const params = useParams();
  const { microsoftConfigureTab, selectedTeam } = useGlobalContext();
  const [mobileRightSidebarOpen, setMobileRightSidebarOpen] = useState(false);
  const [mobileLeftSidebarOpen, setMobileLeftSidebarOpen] = useState(false);
  const [displayCreateButton, setDisplayCreateButton] = useState(false);
  const [showTodoListTeams, setShowTodoListTeams] = useState(false);
  const [showPollListTeams, setShowPollListTeams] = useState(false);
  const [teamId, setTeamId] = useState(params.teamId);
  const [generalTab, setGeneralTab] = useState({ value: false, name: teamId });
  const [filters, setFilters] = useState({
    type_id: [],
    selectMembers: [],
    taggedMembers: [],
    date_from: null,
    date_to: null,
  });
  const [team, setTeam] = useState(null);
  const [singleTeam, setSingleTeam] = useState();
  const history = useHistory();

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }
  }, [microsoftConfigureTab]);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }

    if (!microsoftConfigureTab && teams.length === 0) {
      return;
    }

    if (params.teamId === "general") {
      setTeamId(teams[0]?.id);
      setGeneralTab({ value: true, name: "general" });
    }

    //eslint-disable-next-line
  }, [teams]);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }

    if (!microsoftConfigureTab && teams.length === 0) {
      return;
    }

    if (generalTab.name !== "general") {
      return;
    }

    if (params.teamId !== "general") {
      setGeneralTab({ value: false, name: "general" });
      return;
    }

    setGeneralTab({ value: true, name: "general" });

    //eslint-disable-next-line
  }, [params.teamId]);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }

    if (["timeline", "wallOfFame"].includes(locationName[3])) {
      scrollToTopOfTimeline();
    }

    //eslint-disable-next-line
  }, [location]);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }

    let isMounted = true;
    try {
      (async () => {
        var teamsResponse = await selectedTeam(teamId);

        if (teamsResponse.data.data.length === 0) {
          teamsResponse = await TeamService.getTeam(teamId);
        }

        if (teamsResponse.data.data.length === 0) {
          history.push("/");
        }

        if (isMounted) {
          setTeam(teamsResponse.data.data[0]);
          setSingleTeam(teamsResponse.data.data[0]);
        }
      })();
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message);
      }
    }

    return () => {
      dispatch(timelineActions.clearAll());
      dispatch(timelineActions.clearAllList());
      dispatch(timelineActions.clearAllPoll());
      dispatch(timelineActions.clearWallOfFameAll());
      isMounted = false;
    };
    //eslint-disable-next-line
  }, [teamId, history]);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }

    dispatch(timelineActions.clearAll());
    allTimelinePost();

    // eslint-disable-next-line
  }, [teamId]);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }

    if (locationName[3] !== "todolist" && !showTodoListTeams) {
      return;
    }

    if (timelineTodoList.length === 0) {
      allTimelineTodoList();
    }

    // eslint-disable-next-line
  }, [teamId, location, showTodoListTeams]);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }

    if (locationName[3] !== "coursebuilder") {
      return;
    }

    if (!team) {
      return;
    }

    getAllCourses();

    // eslint-disable-next-line
  }, [teamId, location, team]);

  // useEffect(() => {
  //   if (microsoftConfigureTab) {
  //     microsoftTeams.app.notifySuccess();
  //   }

  //   if (locationName[3] !== "innovation-vista") {
  //     return;
  //   }

  //   if (!team) {
  //     return;
  //   }

  // if (companyData.length === 0 && team.company) {
  //   allCompanyDashboard();
  // }

  // eslint-disable-next-line
  // }, [teamId, location, team]);

  useEffect(() => {
    if (microsoftConfigureTab) {
      microsoftTeams.app.notifySuccess();
    }

    if (locationName[3] !== "poll" && !showPollListTeams) {
      return;
    }

    if (pollQuestion.length === 0) {
      allTimelinePollList();
    }

    // eslint-disable-next-line
  }, [teamId, location, showPollListTeams]);

  const switchRoutes = (
    <>
      {!team && <Loader loaderClass={"timelineMainLoader"} />}
      {team && (
        <Switch>
          {team_routes.map((prop, key) => {
            return (
              <Route
                key={key}
                exact
                path={prop.layout + prop?.path}
                component={prop?.component}
              />
            );
          })}
          <Redirect
            from={`/teams/${teamId}`}
            to={`/teams/${teamId}/timeline`}
          />
        </Switch>
      )}
    </>
  );

  const allTimelinePost = async (
    page = 1,
    sort = sortData,
    filter = filters
  ) => {
    try {
      dispatch(timelineActions.setLoader(true));
      const response = await TeamService.getTimeline(
        teamId,
        page,
        null,
        sort,
        filter
      );

      dispatch(
        timelineActions.getAllTimeline(
          response.data.data,
          response?.data?.meta?.total
        )
      );

      if (sort) {
        setSortData(sort);
      }

      dispatch(timelineActions.setLoader(false));
    } catch (e) {
      console.log(e.response.data.status);
    }
  };

  const createNewPost = (postData, postId, postUpdated, type) => {
    const newPost = {
      data: {
        ...postData,
      },
      team_id: teamId,
      type: type.name,
      updated_at: postUpdated,
      is_forwarded: false,
      buzz_type_id: null,
      buzzes_count: 0,
      content: "Initiated team todo list",
      current_user_buzz: null,
      expressions_count: 0,
      is_private: false,
      original_post: null,
      recent_buzz_activity_user: null,
      recent_expressed_activity_user: null,
      status_id: 1,
      type_id: type.id,
      user_expressed: false,
      id: postId,
      user: {
        ...user,
      },
    };

    dispatch(timelineActions.createPost(newPost));
  };

  const deleteNewPost = (post) => {
    dispatch(timelineActions.deletePost(post));
  };

  const allTimelinePollList = async (page = 1) => {
    try {
      dispatch(timelineActions.setPollLoader(true));
      const teamIdd = teamId || "";
      const response = await pollServices.getAllPoll(teamIdd, page);

      dispatch(
        timelineActions.getAllPollList(
          response.data.data,
          response?.data?.meta?.total
        )
      );

      dispatch(timelineActions.setPollLoader(false));
    } catch (e) {
      console.log(e);
    }
  };

  const allTimelineTodoList = async (page = 1) => {
    try {
      dispatch(timelineActions.setListLoader(true));
      const response = await TeamService.getTodoList(teamId, page);

      dispatch(
        timelineActions.getAllList(
          response.data.data,
          response?.data?.meta?.total
        )
      );

      dispatch(timelineActions.setListLoader(false));
    } catch (e) {
      console.log(e);
    }
  };

  const getAllCourses = async (page = 1, order_by = "oldest", status_id = null) => {
    try {
      dispatch(timelineActions.setCourseLoader(true));
      
      // Clear all courses when fetching the first page
      if (page === 1) {
        dispatch(timelineActions.clearAllCourses());
      }
      
      const response = await CourseService.getAllCourses({
        page,
        limit: 10,
        teamId,
        order_by,
        status_id
      });

      dispatch(
        timelineActions.getAllCourses(
          response.data.data,
          response?.data?.meta?.total
        )
      );

      dispatch(timelineActions.setCourseLoader(false));
    } catch (e) {
      console.log(e);
      dispatch(timelineActions.setCourseLoader(false));
    }
  };

  const allCompanyDashboard = async (page = 1) => {
    try {
      if (team.company) {
        dispatch(timelineActions.setCompanyLoader(true));
        const response = await TeamService.getInnovistaCompanyTimeline(
          team?.company?.id,
          page
        );

        dispatch(
          timelineActions.getAllCompanyData(
            response.data.data,
            response?.data?.meta?.total
          )
        );
      }

      dispatch(timelineActions.setCompanyLoader(false));

      if (!team.company) {
        console.log("here");
        dispatch(timelineActions.setTotal(0));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const rightToggleDrawer = () => {
    setMobileRightSidebarOpen(!mobileRightSidebarOpen);
  };

  const closeDrawer = () => {
    setMobileRightSidebarOpen(false);
    setMobileLeftSidebarOpen(false);
  };

  const handleLeftSidebarDrawer = () => {
    setMobileLeftSidebarOpen(!mobileLeftSidebarOpen);
  };

  const handleScroll = (val) => {
    if (val.scrollTop === 0) {
      setDisplayCreateButton(false);
    }

    if (val.scrollTop >= 120 && val.scrollTop <= 220) {
      setDisplayCreateButton(true);
      return;
    }
  };

  return (
    <TeamContext.Provider
      value={{
        team,
        singleTeam,
        setTeam,
      }}
    >
      <TeamActionContext.Provider
        value={{
          createNewPost,
          closeDrawer,
          deleteNewPost,
          mobileRightSidebarOpen,
          allCompanyDashboard,
          allTimelineTodoList,
          teamId,
          setTeamId,
          filters,
          generalTab,
          setGeneralTab,
          allTimelinePost,
          sortData,
          setFilters,
          allTimelinePollList,
          setShowTodoListTeams,
          setShowPollListTeams,
          displayCreateButton,
          getAllCourses,
        }}
      >
        <div className="dashboard timeline-screens">
          <Navbar
            team={team}
            teamId={teamId}
            setGeneralTab={setGeneralTab}
            generalTab={generalTab}
            setTeamId={setTeamId}
            routes={filteredRoutes}
            teamNavbar={true}
            handleLeftSidebarDrawer={handleLeftSidebarDrawer}
            handleRightSidebarDrawer={rightToggleDrawer}
          />
          <div className="content teamContent">
            <div className="row teamTimelineRow">
              {!microsoftConfigureTab && (
                <Sidebar
                  open={mobileLeftSidebarOpen}
                  closeLeftDrawer={closeDrawer}
                  routes={team_routes}
                  color={color}
                  team={team}
                  rtlActive={true}
                  isTeam={true}
                  {...rest}
                />
              )}
              <div
                className={classNames({
                  "col-lg-12": !team ? true : false,
                  "col-lg-6": locationName[3] !== "watercooler" ? true : false,
                  "col-lg-9":
                    locationName[3] === "watercooler" || microsoftConfigureTab
                      ? true
                      : false,
                  microsoftTeamMiddleContent: microsoftConfigureTab
                    ? true
                    : false,
                  middleTeamContent: !microsoftConfigureTab ? true : false,
                  "col-xl-12": !team ? true : false,
                  "col-xl-6": locationName[3] !== "watercooler" ? true : false,
                  "col-xl-9":
                    locationName[3] === "watercooler" || microsoftConfigureTab
                      ? true
                      : false,
                  "middle-content": true,
                })}
                id="main-panel-right"
              >
                <Scrollbar onScroll={handleScroll}>
                  <div
                    style={{ display: "flex", justifyContent: "center" }}
                    id="timeline-container"
                  >
                    <div
                      className={classNames({
                        timelineRoot: true,
                        maxWidthTimeline:
                          locationName[3] !== "watercooler" && 
                          locationName[3] !== "coursebuilder" && 
                          locationName[3] !== "courses" && 
                          locationName[3] !== "growth-partner-courses" ? true : false,
                      })}
                    >
                      {switchRoutes}
                    </div>
                  </div>
                </Scrollbar>
              </div>
              {team && (
                <RightSidebar
                  closeRightDrawer={closeDrawer}
                  open={mobileRightSidebarOpen}
                  team={team}
                />
              )}
            </div>
          </div>
          {!microsoftConfigureTab && (
            <Footer routes={filteredRoutes} teamNavbar={true} />
          )}
        </div>
      </TeamActionContext.Provider>
    </TeamContext.Provider>
  );
}
